<!-- eslint-disable prettier/prettier -->
<template>
  <PageView
    :main-title="
      usersService.hasAnyProfile(loggedUser, [
        PROFIL_UTILISATEUR.ANIMATEUR_REGIONAL,
        PROFIL_UTILISATEUR.ACCOMPAGNATEUR_REGIONAL,
      ])
        ? $t('menu.contact-porteurs-projet')
        : $t('usersList.title')
    "
    no-sub-title-expected
  >
    <ContentView wide-screen>
      <GraeContactView :logged-user="loggedUser" />
    </ContentView>
  </PageView>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { UtilisateurDTO } from "@/model/bean/GeneratedDTOs"

import { LoginService } from "@/services/rest/login/LoginService"
import { UsersService } from "@/services/rest/users/UsersService"
import { PROFIL_UTILISATEUR } from "@/model/bean/EnumHelper"

import PageView from "@/views/commons/PageView.vue"
import ContentView from "@/views/commons/ContentView.vue"
import GraeContactView from "@/pages/grae/GraeContactView.vue"

export default defineComponent({
  name: "UsersListPage",
  components: {
    GraeContactView,
    PageView,
    ContentView,
  },
  props: {
    graeId: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      PROFIL_UTILISATEUR,
      loginService: LoginService.INSTANCE,
      usersService: UsersService.INSTANCE,
      loggedUser: undefined as UtilisateurDTO | undefined,
    }
  },
  created(): void {
    this.loggedUser = this.loginService.getLoggedUser()
  },
})
</script>
